const api = "https://pwoly-blogs.onrender.com"
// const api = 'http://localhost:5000'
export const API_URI = api